import { VideoPlayerRiv } from "@/components/VideoPlayer/VideoPlayerRiv";

type PanelEmptyStateProps = {
  /** File name in `public/riv/`, without the extension. */
  riv: string;
  title: string;
};

/**
 * The one empty state of the guest-detail side panel. Every tab used to build
 * its own: a 200px figure under the appointment buttons, an 80px one in grey
 * for attachments, bare text at the top of the notes — clicking through the
 * rail showed six different screens for the same "nothing here yet".
 *
 * Sized for the panel, not the page: the content column is ~286px wide, so the
 * page-level `w-35 sm:w-45 lg:w-55` recipe swallows it. `flex-1` centres it in
 * whatever room the tab leaves between its own header and footer — the tab
 * root has to be a `flex flex-col` with a height for that to land.
 */
export const PanelEmptyState: React.FC<PanelEmptyStateProps> = ({
  riv,
  title,
}) => (
  <div
    data-testid="guest-panel-empty"
    data-riv={riv}
    className="flex flex-1 flex-col items-center justify-center gap-3 px-4 py-8 text-center"
  >
    {/* The box holds the size on its own: VideoPlayerRiv is lazy with a null
        fallback, so without it the title paints first and jumps once the
        figure arrives. */}
    <div className="size-32 shrink-0" aria-hidden="true">
      <VideoPlayerRiv videoName={riv} width="w-full" height="h-full" />
    </div>
    <p className="body-2-bold font-primary max-w-56">{title}</p>
  </div>
);
